<script lang="ts" setup>
import type { IProps } from './Top.types'

const { type = 'text' } = defineProps<IProps>()

</script>

<template>
  <section :class="['top', `top--${type}`]">
    <div class="top__item">
      <h1
        class="top__header"
        v-html="header"
      />

      <h2
        v-if="subheader"
        class="top__subheader"
        v-html="subheader"
      />

      <div
        class="top__text"
        v-html="text"
      />

      <UiButton
        v-if="button"
        class="top__button"
        variant="primary"
        :to="button.to"
      >
        <span
          v-if="button.icon"
          class="top__icon"
        >
          <img
            class="top__img"
            width="24px"
            height="24px"
            alt=""
            :src="button.icon"
          >
        </span>
        {{ button.text }}
      </UiButton>
    </div>

    <div
      v-if="image && type === 'image'"
      class="top__item top__item--image"
    >
      <img
        :src="image"
        class="top__item-img"
      >
    </div>
  </section>
</template>

<style lang="scss" scoped>
.top {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 41rem;
  padding: 8.8rem 2.8rem 0;
  overflow: hidden;

  background-image: url('/images/top/top-bg_m.png');
  background-repeat: no-repeat;
  background-position: bottom right;
  background-size: cover;
  border-radius: 0 0 2.4rem 2.4rem;

  &__item {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: flex-start;
    padding: 5rem 0;

    &--image {
      align-items: center;
    }
  }

  &__item-img {
    width: auto;
    max-height: 44.4rem;
    height: 100%;
    background-color: aqua;
  }

  &__header {
    @include h5;
    margin-bottom: 3.2rem;
  }

  &__subheader {
    @include h10;
    margin-bottom: 3.2rem;
  }

  &__text {
    @include h10;
    margin-bottom: 4rem;

    :deep(br) {
      display: none;
    }
  }

  &--image {
      min-height: 64.3rem;
  }

  &__icon {
    display: inline-block;
    padding-right: 1.2rem;

    img {
      width: 24px;
      height: 24px;
    }
  }
}

@include atS {
  .top {
    flex-direction: row;

    &__item {
      padding: 5rem 8.6rem;

      &:first-of-type {
        padding-left: 17.2rem;
      }
    }

    &__header {
      @include h4;
    }
  }
}

@include atM {
  .top {
    background-image: url('/images/top/top-bg.jpg');
    background-repeat: no-repeat;
    background-position: bottom right;
    background-size: cover;

    &__header {
      @include h3;
    }

    &__subheader {
      @include h7;
    }

    &__text {
      @include body-1-medium;

      :deep(br) {
        display: inline;
      }
    }
  }
}

@include atXL {
  .top {
    &__header {
      @include h1;
    }
  }
}
</style>
